var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('story-content',{attrs:{"year":_vm.year,"month":_vm.month,"day":_vm.day,"filename":_vm.filename}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }